<ion-content [fullscreen]="true">
  <ion-refresher
    id="refresher"
    slot="fixed"
    (ionRefresh)="doRefresh($event)"
    [disabled]="!this.platform.is('capacitor')"
  >
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>

  <ion-grid>
    <ion-row>
      <ion-col>
        <app-info-varsling-popup
          *ngFor="let i = index; let message; of: infoMessages"
          [popupId]="i"
          [message]="message"
        ></app-info-varsling-popup>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-title [class.desktop]="this.platform.is('desktop')">
          <!-- Mine Strømavtaler -->
          <h1>Mine strøm&#173;avtaler</h1>
        </ion-title>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="ion-padding mt-4" size="12">
        @if (hasFetchingError) {
        <div class="avtaleboks error">
          <p class="errorMessage">
            Klarte ikke hente avtaler. Prøv igjen senere eller kontakt oss om
            problemet vedvarer.
          </p>
        </div>
        } @else { @if (mineAvtaler) {
        <div class="avtale-liste">
          <app-avtale-kort
            *ngFor="let avtale of mineAvtaler"
            [avtale]="avtale"
            [avtalemode]="1"
          >
          </app-avtale-kort>
        </div>
        @if (mineAvtaler?.length === 0) {
        <div>
          <ion-grid>
            <ion-row>
              <ion-col class="ingen-avtale-boks">
                <p>Vi finner ingen aktive avtaler for din bruker.</p>
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>
        } } @else {
        <div class="avtaleboks"><ion-spinner name="dots"></ion-spinner></div>
        } @if (mineFremtidigeAvtaler?.length > 0) {
        <div>
          <ion-title>
            <div>Fremtidige avtaler</div>
          </ion-title>
          <ion-grid
            class="cardContainer"
            *ngFor="let item of mineFremtidigeAvtaler"
          >
            <ion-row>
              <ion-col>
                <h1>{{item.adresse}}</h1>
                <h2 size="small" class="avtale-title">{{ item.produkt }}</h2>
                <p class="center noMargin">
                  Starter opp {{item.fradato | date:'dd.MM.yyyy':'':'nb'}}
                </p>
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>

        } }
      </ion-col>
    </ion-row>
  </ion-grid>
  <div class="tab-content-bottom-margin"></div>
</ion-content>
